<template>
    <div id="InvoiceMainView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="cantAccessPage === true">
            <invoice-view-sidebar></invoice-view-sidebar>
        </template>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section workorder-left-section">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name workorder-pagetitle basic-form-container">
                        Invoice View
                        <!-- <template v-if="canListInvoice == true"> -->
                            <router-link class="btn btn-success waves-effect pull-right mr-0" v-bind:to="{name: 'ListInvoice'}"> <i class="hi-icon icon-flback"></i> Back</router-link>
                        <!-- </template> -->
                        <button v-if="invoiceOrigin != 'system'" type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-success waves-effect pull-right"><i class="hi-icon icon-flpencil"></i> Edit
                        </button>

                        <button type="submit" id="editInvoiceBtn" v-on:click="generateInvoicePdf()" class="btn btn-success waves-effect pull-right"><i class="hi-icon icon-flexport"></i> Download PDF
                        </button>

                        <button type="submit" id="previewInvoiceBtn" v-on:click="previewInvoice()" class="btn btn-success waves-effect pull-right"><i class="hi-icon icon-flexport"></i> Preview Invoice
                        </button>
                    </div>
                    <template v-if="invoiceOrigin == 'manual' && invoiceType == 'WO'">
                        <invoice-view-workorder></invoice-view-workorder>
                    </template>
                    <template v-else-if="invoiceOrigin == 'manual'">
                        <invoice-view-manual></invoice-view-manual>
                    </template>
                    <template v-else-if="invoiceOrigin == 'system'  && invoiceType == 'PE'">
                        <invoice-view-permit></invoice-view-permit>
                    </template>
                    <template v-else-if="invoiceOrigin == 'system'">
                        <invoice-view-rental-contract></invoice-view-rental-contract>
                    </template>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <!-- <template v-if="cantAccessPage === true">
            <template v-if="invoiceOrigin == 'manual' && invoiceType == 'WO'">
                <invoice-view-workorder></invoice-view-workorder>
            </template>
            <template v-else-if="invoiceOrigin == 'manual'">
                <invoice-view-manual></invoice-view-manual>
            </template>
            <invoice-view-sidebar></invoice-view-sidebar>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="col-md-12">
                <div class="error-template">
                    <h1>Oops!</h1>
                    <h2>403</h2>
                    <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template> -->
    </div>
</template>
<script>
import Vue from 'vue';

import {commonMixins} from '../../mixins/commonMixins';
import InvoiceViewSidebar from '@/components/invoice/InvoiceViewSidebar';
import ManualInvoiceView from '@/components/invoice/ManualInvoiceView';
import WorkOrderSalesInvoiceView from '@/components/invoice/WorkOrderSalesInvoiceView';
import RentalContractInvoiceView from '@/components/invoice/RentalContractInvoiceView';
import PermitInvoice from '@/components/invoice/PermitInvoice';


Vue.component("invoice-view-sidebar", InvoiceViewSidebar);
Vue.component("invoice-view-manual",ManualInvoiceView);
Vue.component("invoice-view-workorder", WorkOrderSalesInvoiceView);
Vue.component("invoice-view-rental-contract", RentalContractInvoiceView);
Vue.component("invoice-view-permit", PermitInvoice);

export default {
    name: "InvoiceMainView",

    mixins:[commonMixins],
    data: () => ({
        loading:false,
        permissions:[],
        cantAccessPage:"",
        invoiceId:0,
        invoiceType:"",
        invoiceOrigin:"manual",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.invoiceId = this.$route.params.id;
        self.invoiceOrigin = localStorage.getItem('invoice_origin');
        self.invoiceType = localStorage.getItem('invoice_type');
        self.getPermissions();
    },
    methods : {

        invoiceDetail(invoiceId,invoiceType,invoiceOrigin) {
            var self = this;

            self.invoiceId = invoiceId;
            self.invoiceType = invoiceType;
            self.invoiceOrigin = invoiceOrigin;
            localStorage.setItem("invoice_id",invoiceId);
            localStorage.setItem("invoice_origin",invoiceOrigin);
            localStorage.setItem("invoice_type",invoiceType);
            if (invoiceOrigin == "manual" && invoiceType == "WO") {
                self.$root.$emit('invoice_work_order',self.invoiceId);
            }else if(invoiceOrigin == "manual"){
                self.$root.$emit('invoice_manual',self.invoiceId);
            }else if(invoiceOrigin == "system" && invoiceType == "PE"){
                self.$root.$emit('invoice_system_permit',self.invoiceId);
            }else if(invoiceOrigin == "system"){
                self.$root.$emit('invoice_system',self.invoiceId);
            }
        },
        backBtn(){
            var self = this;
            self.$router.push("/invoice/list/");
        },
        editInvoice() {
            var self = this;
            if (self.invoiceOrigin == "manual" && self.invoiceType == "WO") {
                self.$router.push("/invoice/wo/edit/" + self.invoiceId);
            }else{
                self.$router.push("/invoice/edit/" + self.invoiceId);
            }
        },
        generateInvoicePdf(){

            var self = this;

            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:self.invoiceType,
                    invoice_origin:self.invoiceOrigin
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.error = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem('user_obj');
                            localStorage.removeItem('tkn');

                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });

        },
        previewInvoice() {
            var self = this;
            if (self.invoiceOrigin == "manual" && self.invoiceType == "WO") {
                self.$router.push("/invoice/wo/view/" + self.invoiceId);
            }else if(self.invoiceOrigin == "manual") {
                self.$router.push("/invoice/manual/template/" + self.invoiceId);
            }else if(self.invoiceOrigin == "system" && self.invoiceType == "PE") {
                self.$router.push("/invoice/permit/template/" + self.invoiceId);
            }else{
                self.$router.push("/invoice/view/" + self.invoiceId);
            }
        }

    }
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/InvoiceMainView.vue